import { render, staticRenderFns } from "./AsociarDispositivos.vue?vue&type=template&id=1b396671&"
import script from "./AsociarDispositivos.vue?vue&type=script&lang=ts&"
export * from "./AsociarDispositivos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports